(() => {
  const PRODUCT_ID = '12201821667592';
  const SINGLE_PACK_VARIANT_ID = '58522100039944';
  const THREE_PACK_VARIANT_ID = '58562652602632';
  const UNIT_PRICES = {
    '58522100039944': '29,93 €/kg',
    '58562652602632': '31,09 €/kg'
  };

  function directChildUnder(ancestor, node) {
    if (!ancestor || !node || !ancestor.contains(node)) return null;
    let current = node;
    while (current.parentElement && current.parentElement !== ancestor) {
      current = current.parentElement;
    }
    return current.parentElement === ancestor ? current : null;
  }

  function findSharedBlockContainer(a, b) {
    let ancestor = a?.parentElement;
    while (ancestor) {
      if (ancestor.contains(b)) {
        const childA = directChildUnder(ancestor, a);
        const childB = directChildUnder(ancestor, b);
        if (childA && childB && childA !== childB) return { ancestor, childA, childB };
      }
      ancestor = ancestor.parentElement;
    }
    return null;
  }

  function bindExclusiveAccordions(container) {
    if (!container) return;

    const details = [...container.querySelectorAll('details')];
    const initiallyOpen = details.filter(item => item.open);
    initiallyOpen.slice(1).forEach(item => { item.open = false; });

    details.forEach((item) => {
      if (item.dataset.juvioExclusiveAccordion === 'true') return;

      item.addEventListener('toggle', () => {
        if (!item.open) return;

        details.forEach((other) => {
          if (other !== item && other.open) other.open = false;
        });
      });

      item.dataset.juvioExclusiveAccordion = 'true';
    });
  }

  function moveDescriptionBelowBuyButtons(root) {
    const buyButtons = root.querySelector('.buy-buttons-block');
    const descriptionHeading = [...root.querySelectorAll('h3')].find(el => el.textContent.trim() === 'Beschreibung');
    if (!buyButtons || !descriptionHeading) return null;

    const rte = descriptionHeading.closest('.rte') || descriptionHeading.parentElement;
    const shared = findSharedBlockContainer(buyButtons, rte);
    if (shared) {
      const { childA: buyBlock, childB: descriptionBlock } = shared;
      if (buyBlock.nextElementSibling !== descriptionBlock) {
        buyBlock.insertAdjacentElement('afterend', descriptionBlock);
      }
      return { rte, descriptionBlock };
    }
    return { rte, descriptionBlock: null };
  }

  function getSelectedVariantId(picker) {
    const checked = picker.querySelector('input[type="radio"]:checked');
    return checked?.dataset.variantId || '';
  }

  function updateTaxNote(root, picker) {
    const taxNote = root.querySelector('product-price .tax-note') || root.querySelector('.tax-note');
    if (!taxNote) return false;

    const variantId = getSelectedVariantId(picker);

    if (variantId === THREE_PACK_VARIANT_ID) {
      taxNote.textContent = 'inkl. MwSt.';
    } else {
      taxNote.innerHTML = 'inkl. MwSt., zzgl. 3,51 € <a href="#versand-lieferung" class="tax-note__shipping-link" data-shipping-disclosure-link>Versandkosten</a>';
    }

    return true;
  }

  function updateUnitPrice(root, picker) {
    const variantId = getSelectedVariantId(picker);
    const unitPriceText = UNIT_PRICES[variantId] || UNIT_PRICES[SINGLE_PACK_VARIANT_ID];
    const taxNote = root.querySelector('product-price .tax-note') || root.querySelector('.tax-note');
    if (!taxNote) return false;

    let unitPrice = root.querySelector('.juvio-unit-price');
    if (!unitPrice) {
      unitPrice = document.createElement('p');
      unitPrice.className = 'juvio-unit-price';
      unitPrice.style.margin = '4px 0 0';
      unitPrice.style.fontSize = '.78rem';
      unitPrice.style.lineHeight = '1.35';
      unitPrice.style.opacity = '.72';
      taxNote.insertAdjacentElement('afterend', unitPrice);
    } else if (unitPrice.previousElementSibling !== taxNote) {
      taxNote.insertAdjacentElement('afterend', unitPrice);
    }

    unitPrice.textContent = unitPriceText;
    return true;
  }

  function bindShippingLink(root) {
    if (root.dataset.juvioShippingLinkBound === 'true') return;

    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-shipping-disclosure-link]');
      if (!link) return;

      const details = document.getElementById('versand-lieferung');
      if (!details) return;

      event.preventDefault();
      details.open = true;
      history.replaceState(null, '', '#versand-lieferung');
      requestAnimationFrame(() => {
        details.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    root.dataset.juvioShippingLinkBound = 'true';
  }

  async function loadMetafieldContent(root) {
    if (root.dataset.juvioMetafieldsLoaded === 'true') return;
    root.dataset.juvioMetafieldsLoaded = 'loading';

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', 'juvio-product-details');
      const response = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Section render failed: ${response.status}`);

      const html = await response.text();
      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const dynamic = template.content.querySelector('[data-juvio-product-details]');
      if (!dynamic) throw new Error('JUVIO metafield section not found');

      const current = moveDescriptionBelowBuyButtons(root);
      if (current?.rte) {
        current.rte.innerHTML = dynamic.innerHTML;
        bindExclusiveAccordions(current.rte);
      }

      const subtitleText = dynamic.dataset.juvioSubtitle || '';
      const h1 = root.querySelector('h1');
      let subtitle = root.querySelector('.juvio-product-subtitle');
      if (h1 && subtitleText) {
        if (!subtitle) {
          subtitle = document.createElement('p');
          subtitle.className = 'juvio-product-subtitle';
          h1.insertAdjacentElement('afterend', subtitle);
        }
        subtitle.textContent = subtitleText;
      } else if (subtitle) {
        subtitle.remove();
      }

      root.dataset.juvioMetafieldsLoaded = 'true';
    } catch (error) {
      console.warn('[JUVIO] Could not load metafield content', error);
      root.dataset.juvioMetafieldsLoaded = 'false';
    }
  }

  function applyLayout() {
    const picker = document.querySelector(`variant-picker[data-product-id="${PRODUCT_ID}"]`);
    if (!picker) return false;

    const root = picker.closest('.product-details') || document;
    if (root.classList) root.classList.add('juvio-product-page');

    const current = moveDescriptionBelowBuyButtons(root);
    bindExclusiveAccordions(current?.rte);
    bindShippingLink(root);

    if (!root.querySelector('.juvio-free-shipping')) {
      const note = document.createElement('p');
      note.className = 'juvio-free-shipping';
      note.textContent = 'Kostenloser Versand';
      note.hidden = true;
      picker.insertAdjacentElement('afterend', note);
    }

    const shippingNote = root.querySelector('.juvio-free-shipping');
    const updateShipping = () => {
      if (!shippingNote) return;
      const checked = picker.querySelector('input[type="radio"]:checked');
      const variantId = checked?.dataset.variantId || '';
      const value = checked?.value || '';
      shippingNote.hidden = !(variantId === THREE_PACK_VARIANT_ID || value.includes('3er-Pack'));
    };

    const refreshVariantUI = () => {
      updateShipping();
      updateTaxNote(root, picker);
      updateUnitPrice(root, picker);
    };

    if (!picker.dataset.juvioBound) {
      picker.addEventListener('change', () => {
        requestAnimationFrame(refreshVariantUI);
        setTimeout(refreshVariantUI, 120);
        setTimeout(refreshVariantUI, 300);
      });
      picker.dataset.juvioBound = 'true';
    }

    refreshVariantUI();
    setTimeout(refreshVariantUI, 150);
    loadMetafieldContent(root);
    return true;
  }

  function initWithRetries() {
    let attempts = 0;
    const run = () => {
      attempts += 1;
      const done = applyLayout();
      if (!done && attempts < 20) setTimeout(run, 150);
    };
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWithRetries, { once: true });
  } else {
    initWithRetries();
  }

  document.addEventListener('shopify:section:load', initWithRetries);
})();